import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { listActiveUsers } from '../../api/admin';
import { Select } from '../ui/Input';
import { joinName } from '../../utils/format';

export default function UserPicker({ value, onChange, placeholder = 'Select user...', ...rest }) {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-users', 'active'],
    queryFn: listActiveUsers,
    staleTime: 60_000,
  });

  return (
    <Select
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value ? Number(e.target.value) : null)}
      disabled={isLoading}
      {...rest}
    >
      <option value="">{isLoading ? 'Loading...' : placeholder}</option>
      {(data || []).map((u) => (
        <option key={u.id} value={u.id}>
          {u.employeeId ? `${u.employeeId} — ` : ''}
          {joinName(u.firstName, u.middleName, u.lastName) || u.username}
        </option>
      ))}
    </Select>
  );
}
